import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      await login(email, password);
    } catch (err) {
      setError('Failed to sign in');
      console.error(err);
    }
    setLoading(false);
  }

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--sca-cream)' }}>
      <div className="max-w-md w-full space-y-8 p-8 rounded-2xl shadow-sm border" style={{ backgroundColor: 'var(--sca-card)', borderColor: 'var(--sca-border)' }}>
        <div className="flex flex-col items-center">
          <img src="/scanalytics-logo-square.png" alt="Scanalytics" className="h-16 w-16 mb-4" />
          <h2 className="text-center text-2xl font-semibold" style={{ color: 'var(--sca-ink)' }}>
            Demo Dashboard
          </h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && (
            <div className="border px-4 py-3 rounded-lg relative" style={{ backgroundColor: '#fee', borderColor: '#fcc', color: '#c33' }}>
              {error}
            </div>
          )}
          <div className="rounded-xl -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border placeholder-gray-400 rounded-t-xl focus:outline-none focus:ring-2 focus:z-10 sm:text-sm"
                style={{ borderColor: 'var(--sca-border)', color: 'var(--sca-ink)', backgroundColor: 'var(--sca-card)' }}
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border placeholder-gray-400 rounded-b-xl focus:outline-none focus:ring-2 focus:z-10 sm:text-sm"
                style={{ borderColor: 'var(--sca-border)', color: 'var(--sca-ink)', backgroundColor: 'var(--sca-card)' }}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2.5 px-4 border border-transparent text-sm font-medium rounded-full text-white focus:outline-none focus:ring-2 focus:ring-offset-2 transition-colors"
              style={{ backgroundColor: 'var(--sca-ink)' }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2a2a2a'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--sca-ink)'}
            >
              {loading ? 'Signing in...' : 'Sign in'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login; 